import styled from '@emotion/styled'

export const Notes = styled.div`
  color: #666565;
  font-size: 11px;
  margin: 2rem 0;
  text-align: center;
`
